var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_254_1107)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_254_1107",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99968 15.1663C8.87532 15.1675 9.74256 14.9956 10.5515 14.6605C11.3605 14.3253 12.0953 13.8337 12.7137 13.2137C13.3337 12.5953 13.8253 11.8605 14.1605 11.0515C14.4956 10.2426 14.6675 9.37532 14.6663 8.49968C14.6675 7.62404 14.4955 6.75681 14.1604 5.94782C13.8253 5.13884 13.3337 4.40405 12.7137 3.78568C12.0953 3.16569 11.3605 2.67401 10.5515 2.33891C9.74256 2.0038 8.87532 1.83188 7.99968 1.83301C7.12404 1.8319 6.25681 2.00383 5.44782 2.33893C4.63884 2.67404 3.90405 3.1657 3.28568 3.78568C2.6657 4.40405 2.17404 5.13884 1.83893 5.94782C1.50383 6.75681 1.3319 7.62404 1.33301 8.49968C1.33188 9.37532 1.5038 10.2426 1.83891 11.0515C2.17401 11.8605 2.66569 12.5953 3.28568 13.2137C3.90405 13.8337 4.63884 14.3253 5.44782 14.6604C6.25681 14.9955 7.12404 15.1675 7.99968 15.1663Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33301 8.5L7.33301 10.5L11.333 6.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_254_1107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5H16V16.5H0V0.5Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_254_1107"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPass);
export default __webpack_public_path__ + "static/media/pass.87fdc8f3100cc0db7b677dfd19d32682.svg";
export { ForwardRef as ReactComponent };